import { common } from "./components/common";
import { hamburgerMenuButton } from "./components/hamburgerMenuButton";
import { slider } from "./components/slider";
import { hamburgerAccordion, accordion } from "./components/accordion";
import { sidebarMenu } from "./components/sidebarMenu";
import { tab, tabLink } from "./components/tab";
import { inputAutoFill, errorMessage, setConsultationCode } from "./components/contact";
import "modaal/dist/js/modaal.min.js";
import "modaal/dist/css/modaal.min.css";

$(document).ready(function () {
  (() => {
    common();
  })();

  (() => {
    /*
    ハンバーガーメニュー用関数
    */
    //ハンバーガーメニューボタン定義
    const buttonEl = "#hamburgerButton";
    //ハンバーガーメニュー定義
    const menuEl = "#hamburgerMenu";
    hamburgerMenuButton(buttonEl, menuEl);
  })();

  (() => {
    /*
    スライダー用関数
    */
    slider();
  })();

  (() => {
    /*
    アコーディオン用関数
    */
    //アコーディオンラッパー定義
    const accordionEl = ".accordion";
    //アコーディオンボタン定義
    const accordionButtonEl = ".accordionButton";
    //アコーディオンアイテム定義
    const accordionItemEl = ".accordionItem";

    accordion(accordionEl, accordionButtonEl, accordionItemEl);
    hamburgerAccordion();
  })();

  (() => {
    /*
    サイドメニュー用関数
    */
    sidebarMenu();
  })();

  (() => {
    /*
    タブ用関数
    */
    //タブボタンラッパークラス定義
    const tabButtonEl = ".tabButton";
    //タブコンテンツラッパークラス定義
    const tabContentsEl = ".tabContent";
    tab(tabButtonEl, tabContentsEl);

    const tabLinkButton = ".tabLinkButton";
    tabLink(tabLinkButton, tabContentsEl);
  })();

  (() => {
    /*
    フォームの自動入力用関数
    */
    // 住所自動入力ボタン
    inputAutoFill();

    // エラーメッセージの表示
    errorMessage();

    // ご相談内容の識別
    setConsultationCode();
  })();
});
